var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { faCog } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NotificationUtils } from "@yodlee/common-components/dist/utilities";
import { Button, Col, Icon, Popover, Row, Spin, Switch } from "antd";
import React, { useEffect, useState } from "react";
import { DataUtils } from "../../utilities";
var AlertControl = function (_a) {
    var authentication = _a.authentication;
    var _b = useState(), alertsSubscription = _b[0], setAlertsSubscription = _b[1];
    var _c = useState(), loading = _c[0], setLoading = _c[1];
    useEffect(function () {
        DataUtils.systemConfig(authentication).get().then(function (response) {
            setAlertsSubscription(response === null || response === void 0 ? void 0 : response.emailDispatch);
        });
    }, []);
    var updateSubscriptions = function (updatedSubscriptions) {
        setLoading(updatedSubscriptions);
        var tempAlertSubscription = __assign({}, alertsSubscription);
        setAlertsSubscription(updatedSubscriptions);
        DataUtils.systemConfig(authentication).patch(updatedSubscriptions).catch(function (error) {
            setAlertsSubscription(tempAlertSubscription);
            NotificationUtils.warning("Unable to complete this request", "Please try again later", "ghost");
        }).finally(function () {
            setLoading(undefined);
        });
    };
    return (React.createElement(React.Fragment, null, alertsSubscription &&
        React.createElement(Popover, { overlayClassName: "alert-control-overlay", content: React.createElement(React.Fragment, null,
                React.createElement(Row, { style: { display: "flex", flexDirection: "row" }, className: "padding-bottom-sm" },
                    React.createElement(Col, { style: { width: 112 } }, "Site alerts"),
                    React.createElement(Col, null,
                        React.createElement(Switch, { checked: alertsSubscription === null || alertsSubscription === void 0 ? void 0 : alertsSubscription.isSiteAlertEnabled, onChange: function (state) { return updateSubscriptions(__assign(__assign({}, alertsSubscription), { isSiteAlertEnabled: state })); } })),
                    React.createElement(Col, { className: "margin-left-xs" }, (loading === null || loading === void 0 ? void 0 : loading.isSiteAlertEnabled) ?
                        React.createElement(Spin, { size: "small", indicator: React.createElement(Icon, { type: "loading" }) })
                        : (alertsSubscription === null || alertsSubscription === void 0 ? void 0 : alertsSubscription.isSiteAlertEnabled) ? "On" : "Off")),
                React.createElement(Row, { style: { display: "flex", flexDirection: "row" } },
                    React.createElement(Col, { style: { width: 112 } }, "Communications"),
                    React.createElement(Col, null,
                        React.createElement(Switch, { checked: (alertsSubscription === null || alertsSubscription === void 0 ? void 0 : alertsSubscription.isIncidentEnabled) && (alertsSubscription === null || alertsSubscription === void 0 ? void 0 : alertsSubscription.isMaintenanceEnabled), onChange: function (state) { return updateSubscriptions(__assign(__assign({}, alertsSubscription), { isIncidentEnabled: state, isMaintenanceEnabled: state })); } })),
                    React.createElement(Col, { className: "margin-left-xs" }, (loading === null || loading === void 0 ? void 0 : loading.isIncidentEnabled) || (loading === null || loading === void 0 ? void 0 : loading.isMaintenanceEnabled) ?
                        React.createElement(Spin, { size: "small", indicator: React.createElement(Icon, { type: "loading" }) })
                        : (alertsSubscription === null || alertsSubscription === void 0 ? void 0 : alertsSubscription.isIncidentEnabled) && (alertsSubscription === null || alertsSubscription === void 0 ? void 0 : alertsSubscription.isMaintenanceEnabled) ? "On" : "Off"))) },
            React.createElement(Button, { type: "link" },
                React.createElement(FontAwesomeIcon, { className: "margin-right-xs", icon: faCog }),
                "On/Off"))));
};
export default AlertControl;
//# sourceMappingURL=index.js.map